import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import { Grid, Tabs, Tab, CssBaseline, Container, AppBar, Button, IconButton } from '@mui/material/';
import { Menu2, Logout } from 'tabler-icons-react';
import MenuBar from "../components/MenuBar";
import { Navigate, Link, useNavigate } from "react-router-dom";

export default function Header(props) {
    return (<header>
        <MenuBar />
        <div>
            <IconButton sx={{
                gridColumnStart: 3,
                justifySelf: "flex-end",
                width: '40px',
                height: '40px',
            }} onClick={() => { localStorage.removeItem('accessToken'); window.location.reload(); }} ><Logout /></IconButton >
        </div>
    </header >);
}